/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportedCurrency
 */
export interface SupportedCurrency {
    /**
     * 
     * @type {string}
     * @memberof SupportedCurrency
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SupportedCurrency
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof SupportedCurrency
     */
    locale?: string;
}

/**
 * Check if a given object implements the SupportedCurrency interface.
 */
export function instanceOfSupportedCurrency(value: object): value is SupportedCurrency {
    return true;
}

export function SupportedCurrencyFromJSON(json: any): SupportedCurrency {
    return SupportedCurrencyFromJSONTyped(json, false);
}

export function SupportedCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportedCurrency {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'locale': json['locale'] == null ? undefined : json['locale'],
    };
}

export function SupportedCurrencyToJSON(json: any): SupportedCurrency {
    return SupportedCurrencyToJSONTyped(json, false);
}

export function SupportedCurrencyToJSONTyped(value?: SupportedCurrency | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'locale': value['locale'],
    };
}

